import { render, staticRenderFns } from "./AdvisorSideBar.vue?vue&type=template&id=66f18216&"
import script from "./AdvisorSideBar.vue?vue&type=script&lang=js&"
export * from "./AdvisorSideBar.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorSideBar.vue?vue&type=style&index=0&id=66f18216&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports